import { combineReducers } from 'redux';

import {
  SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  SETTING_BILLING_IS_CLICKED_BUTTON_PAY,
  SETTING_BILLING_PAY_BUTTON_MESSAGE,
  SETTING_BILLING_SET_BILLINGS,
  SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES,
  SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_SET_IS_DELETED_OUTLET,
  SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE,
  SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE,
  SETTING_BILLING_SET_RULES,
  SETTING_BILLING_SET_SUBSCRIPTION_STATUS,
  SETTING_BILLING_SET_TOTAL_BILLING_PRICE,
  SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE,
  SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  SETTING_BILLING_SET_STATUS_VALIDATION_COUPON,
  SETTING_BILLING_SET_COUPON_DISCOUNT,
  SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST,
  SETTING_BILLING_SET_COUPON_ERROR_MESSAGE,
  SETTING_BILLING_IS_VALIDATING_COUPON,
  SETTING_BILLING_SET_PURCHASED_STAFFS,
  SETTING_BILLING_SET_IS_EXTENDED_STAFF_SLOTS,
  SETTING_BILLING_SET_SEPARATE_OUTLET,
  SETTING_BILLING_SET_PROGRESS_CURSOR,
  SETTING_BILLING_SET_EXTEND_DATE,
  SETTING_BILLING_SHOW_PRORATE_TEXT,
  SETTING_BILLING_EXPIRED_DATE,
  SETTING_BILLING_SET_OUTLETS,
  SETTING_BILLING_SET_SHOW_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_HIDE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_TOTAL_OUTLET_PRICE,
  SETTING_BILLING_SET_TOTAL_FEATURES_PRICE,
  SETTING_BILLING_SET_SHOW_EMPLOYEE_SLOT,
  SETTING_BILLING_SET_PRORATE_PRICE_PERIODS,
  SETTING_BILLING_SET_STAFF_SLOTS_PRICE,
  SETTING_BILLING_SET_DISCOUNT_SETTINGS,
  SETTING_BILLING_SET_BILLINGS_CALCULATION,
} from '../../actions/setting/billing/constant';
import createReducer from '../../utils/createReducer';

const billings = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SETTING_BILLING_SET_BILLINGS]: (draft, { payload }) => payload.data,
});

const buttonMessage = createReducer('Pay', {
  [SETTING_BILLING_PAY_BUTTON_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.payButtonMessage,
});

const cancelFeatureSubscriptionModalData = createReducer(
  {},
  {
    [SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL]: (
      draft,
      { payload }
    ) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.featureSubscriptionModalData,
  }
);

const countFeatureSubscription = createReducer(0, {
  [SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.countFeatureSubscription,
});

const couponDiscount = createReducer(
  {},
  {
    [SETTING_BILLING_SET_COUPON_DISCOUNT]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.couponDiscount,
  }
);

const couponDiscountRequest = createReducer(
  {},
  {
    [SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.couponDiscountRequest,
  }
);

const couponErrorMessage = createReducer('', {
  [SETTING_BILLING_SET_COUPON_ERROR_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.errorMessage,
});

const currentSubscriptionPlanName = createReducer(null, {
  [SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.planName,
});

const currentSubscriptionRules = createReducer(
  {},
  {
    [SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.newSubscriptionRules,
  }
);

const extendDate = createReducer('', {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SETTING_BILLING_SET_EXTEND_DATE]: (draft, { payload }) => payload.extendDate,
});

const featureSubscriptionPrice = createReducer(
  {},
  {
    [SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.featureSubscriptionPrice,
  }
);

const featureSubscriptionStatus = createReducer([], {
  [SETTING_BILLING_SET_SUBSCRIPTION_STATUS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.data,
});

const isCouponValid = createReducer(true, {
  [SETTING_BILLING_SET_STATUS_VALIDATION_COUPON]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isCouponValid,
});

const isDeleted = createReducer(
  {},
  {
    [SETTING_BILLING_SET_IS_DELETED_OUTLET]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.isDeleted,
  }
);

const isExtended = createReducer(null, {
  [SETTING_BILLING_SET_IS_EXTENDED_STAFF_SLOTS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isExtended,
});

const isProgressCursor = createReducer(false, {
  [SETTING_BILLING_SET_PROGRESS_CURSOR]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isProgress,
});

const isValidatingCoupon = createReducer(false, {
  [SETTING_BILLING_IS_VALIDATING_COUPON]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isValidating,
});

const minMaxAllOutlet = createReducer(
  {},
  {
    [SETTING_BILLING_EXPIRED_DATE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.minMaxAllOutlet,
  }
);

const outletMinMaxDate = createReducer(
  {},
  {
    [SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.minMaxDate,
  }
);

const outlets = createReducer(
  {},
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [SETTING_BILLING_SET_OUTLETS]: (draft, { payload }) => payload.data,
  }
);

const paramsDeactive = createReducer(
  {},
  {
    [SETTING_BILLING_SET_HIDE_SUBSCRIPTION_MODAL]: () => ({}),

    [SETTING_BILLING_SET_SHOW_SUBSCRIPTION_MODAL]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.params,
  }
);

const payButtonClicked = createReducer(false, {
  [SETTING_BILLING_IS_CLICKED_BUTTON_PAY]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.payButtonClicked,
});

const pendingPaymentMessage = createReducer(null, {
  [SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.pendingPaymentMessage,
});

const purchasedStaffs = createReducer([], {
  [SETTING_BILLING_SET_PURCHASED_STAFFS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.purchasedStaffs,
});

const rules = createReducer(
  {},
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [SETTING_BILLING_SET_RULES]: (draft, { payload }) => payload.data,
  }
);

const separateOutlet = createReducer(
  {},
  {
    [SETTING_BILLING_SET_SEPARATE_OUTLET]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.separateOutlet,
  }
);

const showBillingPage = createReducer(true, {});

const showCancelFeatureSubscriptionModal = createReducer(false, {
  [SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL]: () => true,
  [SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL]: () => false,
});

const showMarkSubscriptionModal = createReducer(false, {
  [SETTING_BILLING_SET_HIDE_SUBSCRIPTION_MODAL]: () => false,
  [SETTING_BILLING_SET_SHOW_SUBSCRIPTION_MODAL]: () => true,
});

const showPaymentGatewayErrorModal = createReducer(false, {
  [SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL]: () => true,
  [SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL]: () => false,
});

const showProrate = createReducer('false', {
  [SETTING_BILLING_SHOW_PRORATE_TEXT]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.showProrate,
});

const showSlotEmployee = createReducer(false, {
  [SETTING_BILLING_SET_SHOW_EMPLOYEE_SLOT]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.showSlotEmployee,
});

const totalBillingPrice = createReducer(0, {
  [SETTING_BILLING_SET_TOTAL_BILLING_PRICE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.totalBillingPrice,
});

const totalFeaturePrice = createReducer(0, {
  [SETTING_BILLING_SET_TOTAL_FEATURES_PRICE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.totalFeaturePrice,
});

const totalOutletPrice = createReducer(0, {
  [SETTING_BILLING_SET_TOTAL_OUTLET_PRICE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.totalOutletPrice,
});

const unusedOutletMessage = createReducer(null, {
  [SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.unusedOutletMessage,
});

const proratePricePeriods = createReducer(null, {
  [SETTING_BILLING_SET_PRORATE_PRICE_PERIODS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.proratePricePeriods,
});

const staffSlotsPrice = createReducer(0, {
  [SETTING_BILLING_SET_STAFF_SLOTS_PRICE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.staffSlotsPrice,
});

const discountSettings = createReducer(
  {},
  {
    [SETTING_BILLING_SET_DISCOUNT_SETTINGS]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.discountSettings,
  }
);

const billingsCalculation = createReducer([], {
  [SETTING_BILLING_SET_BILLINGS_CALCULATION]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.billingsCalculation,
});

export default combineReducers({
  billings,
  billingsCalculation,
  buttonMessage,
  cancelFeatureSubscriptionModalData,
  countFeatureSubscription,
  couponDiscount,
  couponDiscountRequest,
  couponErrorMessage,
  currentSubscriptionPlanName,
  currentSubscriptionRules,
  discountSettings,
  extendDate,
  featureSubscriptionPrice,
  featureSubscriptionStatus,
  isCouponValid,
  isDeleted,
  isExtended,
  isProgressCursor,
  isValidatingCoupon,
  minMaxAllOutlet,
  outletMinMaxDate,
  outlets,
  paramsDeactive,
  payButtonClicked,
  pendingPaymentMessage,
  purchasedStaffs,
  rules,
  separateOutlet,
  showBillingPage,
  showCancelFeatureSubscriptionModal,
  showMarkSubscriptionModal,
  showPaymentGatewayErrorModal,
  showProrate,
  showSlotEmployee,
  totalBillingPrice,
  totalFeaturePrice,
  totalOutletPrice,
  unusedOutletMessage,
  proratePricePeriods,
  staffSlotsPrice,
});
